import React from 'react';
import BoxStandard from './BoxStandard';

const Box = () => {
  return <React.Fragment />;
};

Box.Standard = BoxStandard;
export default Box;
